import { messages as validation } from "vee-validate/dist/locale/ru.json";
import { countryList } from "@/locales/properNouns";
import messages from "./json/ru.json";

export default {
  pl: {
    word: "{n} {word}",
  },
  validation: {
    ...validation,
    credit_card: "The {_field_} field must be a valid credit card number",
    required_select: validation.required,
  },
  notificationsText: {
    liked: "{screenName} liked your {type}",
    followed: "{screenName} followed you",
    subscribed: "{screenName} subscribed to you for {price}",
    upgradeSubscription: "{screenName} upgrade subscription to you. Now the subscription level is {price}",
    soldPost: "{screenName} bought your post for {price}",
    soldAttachment: "{screenName} bought your attach for {price}",
    soldEvent: "{screenName} has booked your event {date} for {price}",
    eventPublished: "Upcoming event by {screenName}!",
    eventStarted: "The event has started",
    eventCancelled: "{screenName} canceled the event",
    sendReview: "{screenName} left a comment: {review}",
    sendMentionedReview: "{screenName} replied you: {review}",
    appointmentRequested: "{screenName} requested {appointmentType} with you",
    appointmentApproved: "{screenName} accepted {appointmentType} with you",
    appointmentRejected: "{screenName} declined {appointmentType} with you",
    appointmentCancelled: "{screenName} canceled {appointmentType} with you",
    appointmentReminder: "{screenName} {timeLeft} left before appointment",
    appointmentNoResponse:
      "{screenName} didn’t respond to your {appointmentType} request. Money returned to your wallet",
  },
  ...messages,
  ...countryList,
};
